import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { ICstSped } from "../../model";

export const CstSelect = Select.ofType<ICstSped>();

export const filterCst: ItemPredicate<ICstSped> = (query, produto) => {
  return produto.descricao.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

export const renderCst: ItemRenderer<ICstSped> = (cst, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={cst.cod}
      text={cst.descricao}
      onClick={handleClick}
      label={`${cst.cod}`}
    />
  );
};
